import * as React from "react"
import { cn } from "@/lib/utils"

interface YesNoButtonGroupProps {
  value: boolean | null | undefined;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * YesNoButtonGroup - A toggle button group for Yes/No attestations
 * - Yes selected: Primary (dark blue) background
 * - No selected: Destructive (red) background  
 * - Unselected: Outline style
 */
export function YesNoButtonGroup({ 
  value, 
  onChange, 
  disabled,
  className 
}: YesNoButtonGroupProps) {
  return (
    <div className={cn("flex items-center gap-1", className)}>
      <button
        type="button"
        onClick={() => onChange(true)}
        disabled={disabled}
        className={cn(
          "px-4 py-1.5 text-sm font-medium rounded-md transition-colors",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          "disabled:pointer-events-none disabled:opacity-50",
          value === true
            ? "bg-primary text-primary-foreground hover:bg-primary/90"
            : "border border-input bg-background hover:bg-accent hover:text-accent-foreground"
        )}
      >
        Yes
      </button>
      <button
        type="button"
        onClick={() => onChange(false)}
        disabled={disabled}
        className={cn(
          "px-4 py-1.5 text-sm font-medium rounded-md transition-colors",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          "disabled:pointer-events-none disabled:opacity-50",
          value === false
            ? "bg-destructive text-destructive-foreground hover:bg-destructive/90"
            : "border border-input bg-background hover:bg-accent hover:text-accent-foreground"
        )}
      >
        No
      </button>
    </div>
  );
}

